import _routes from './routes';

export const routes = _routes;

export default routes;



// WEBPACK FOOTER //
// ./containers/Group/UnitReview/index.js